import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { ResponsiveImage, LazyLoadImages } from "@quintype/components";
import { FullScreenImages } from "./FullScreenImages";
import { withElementWrapper } from "./withElementWrapper";
import { ScrollSnap } from "./ScrollSnap";

import "./slideshow.m.css";

const ImageSlideshowBase = (props) => {
  if (!props.element) return null;

  const Slide = (image, index, onClickHandler) => {
    const { id, "image-s3-key": imageS3Key, metadata, title } = image;
    return (
      <div className="story-element story-element-slideshow" styleName="slide" key={id}>
        <figure key={id} styleName="image-container" onClick={() => onClickHandler(index)}>
          <LazyLoadImages margin={"0px"}>
            <ResponsiveImage
              slug={imageS3Key}
              metadata={metadata}
              aspect-ratio={[16, 9]}
              defaultWidth={480}
              widths={[250, 480, 640]}
              imgParams={{ auto: ["format", "compress"] }}
              styleName="image"
              alt={id}
            />
          </LazyLoadImages>
        </figure>
      </div>
    );
  };

  const ImageSlideshowTemplate = ({ onClickHandler }) => {
    const storyElements = get(props, ["element", "story-elements"], []);
    return (
      <div styleName="slideshow">
        <ScrollSnap storyElements={storyElements} slideIndicator={"none"}>
          {storyElements.map((image, index) => Slide(image, index, onClickHandler))}
        </ScrollSnap>
      </div>
    );
  };

  ImageSlideshowTemplate.propTypes = {
    onClickHandler: PropTypes.func,
  };
  return <FullScreenImages template={ImageSlideshowTemplate} element={props.element} />;
};

export const ImageSlideshow = withElementWrapper(ImageSlideshowBase);
